module.exports = __webpack_public_path__ + "static/media/succeed.4ad2b5ae.png";